import React, { Component } from 'react'
import { connect } 			from 'react-redux'
import { teachersAction } 	from '../../actions/contentActions'
import Teachers 			from '../content/Teachers'

class TeachersContainer extends Component {
	render() {
		return(
			<div>
				<Teachers
					accountId={this.props.accountId}
					teachers={this.props.teachers}
					initTeachers={this.props.initTeachers}
					pageChange={this.props.pageChange}
				/>
			</div>
		)
	}
}

TeachersContainer = connect(
	state => ({
       teachers: state.teachers
   }),
   dispatch => ({
       bridge 		: data => dispatch(data),
	   initTeachers : accountId => dispatch(teachersAction(accountId, 1)),
	   pageChange 	: (accountId, page) => dispatch(teachersAction(accountId, page))
   })
)(TeachersContainer);

export default TeachersContainer;



// WEBPACK FOOTER //
// ./src/components/containers/TeachersContainer.js